import React, { createContext, useState, useEffect } from 'react';

// External links
import axios from 'axios';
export const UmbracoContext = createContext();
export const UmbracoProvider = ({ children }) => {
	/* ********************************** */
	/*             AXIOS FETCH            */
	/* ********************************** */

	const [allProjects, setAllProjects] = useState(null);
	const [ongoingProjects, setOngoingProjects] = useState(null);
	const [referenceProjects, setReferenceProjects] = useState(null);
	// get alle prosjekter
	useEffect(() => {
		// setLandingerData(require("testData.json"));

		const url = '/umbraco/api/api/getallprojects';

		axios({
			method: 'get',
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				mode: 'no-cors',

				cache: 'no-cache',
			},
			url: url,
		})
			.then((response) => {
				const data = response.data;
				let activeArray = [];
				let referenceArray = [];
				let allProjectsArray = [];

				data.forEach((project) => {
					if (project.lat !== '') {
					}
					if (project.type === 'referanseprosjekt') {
						let _project = { ...project };
						_project.type = 'reference';
						referenceArray.push(_project);
						allProjectsArray.push(_project);
					}
					if (project.type === 'pågående prosjekt') {
						let _project = { ...project };
						_project.type = 'active';
						activeArray.push(_project);
						allProjectsArray.push(_project);
					}
				});
				setAllProjects(allProjectsArray);
				setOngoingProjects(activeArray);
				setReferenceProjects(referenceArray);
			})
			.catch((e) => {
				console.error(e);
			});
	}, []);

	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const [screenHeight, setScreenHeight] = useState(window.innerHeight);
	const updateSize = () => {
		setScreenWidth(window.innerWidth);
		setScreenHeight(window.innerHeight);
	};
	useEffect(() => {
		window.addEventListener('resize', updateSize);
	}, []);

	const [isTouch, setIsTouch] = useState(true);
	useEffect(() => {
		if ('ontouchstart' in document.body) {
			setIsTouch(true);
		} else {
			setIsTouch(false);
		}
	}, []);
	return (
		<UmbracoContext.Provider
			value={{
				allProjects,
				ongoingProjects,
				referenceProjects,
				screenWidth,
				screenHeight,
				isTouch,
			}}>
			{children}
		</UmbracoContext.Provider>
	);
};
